import { OS } from 'const';

let _uid = 0;
export function uid () {
  return _uid++;
}

export const DEFAULT_DEBOUNCE_DURATION = 500;
export function debounce (method, duration = DEFAULT_DEBOUNCE_DURATION) {
  let timeoutId;

  function debounceWrapper (...args) {
    debounceWrapper.clear();

    timeoutId = setTimeout(() => {
      timeoutId = null;
      method.apply(this, args);
    }, duration);
  }

  debounceWrapper.clear = function () {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  debounceWrapper.fn = method;

  return debounceWrapper;
}

export function easeCubicOut (t) {
  return --t * t * t + 1;
}

export function clamp (min, max, v) {
  return v < min ? min : v > max ? max : v;
}

export const lerp = (x, y, a) => x * (1 - a) + y * a;
export const invlerp = (x, y, a) => (a - x) / (y - x);
// export const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
export const lerpRange = (x1,  y1,  x2,  y2,  a) => lerp(x2, y2, invlerp(x1, y1, a));

export function smoothChange (val, asp = 30) {
  return function _smooth (v) {
    return val -= (val - v) / asp;
  }
}

export function bindScrollSlide ($slider, { dist, gap, dur = 1500 } = {}) {
  return function _scrollSlide (dir) {
    const { offsetWidth, scrollWidth, scrollLeft } = $slider;
    const style = window.getComputedStyle($slider);
    gap = gap || parseInt(style.getPropertyValue('column-gap'), 10) || 0;
    const hasSmoothBehavior = style.getPropertyValue('scroll-behavior') === 'smooth';
    dist = dist || (offsetWidth + gap);

    let nextScroll = scrollLeft + dist * Math.sign(dir || 1);

    // if (nextScroll < 0)
    //   nextScroll = scrollWidth - offsetWidth;
    // else if (nextScroll >= scrollWidth)
    //   nextScroll = 0;

    if (!hasSmoothBehavior) {
      let from = scrollLeft;
      let to = nextScroll;
      let start = Date.now();
      if (OS === 'iOS')
        $slider.style.scrollSnapType = 'none';
      function animate () {
        const now = Date.now();
        const elapsed = now - start;
        const lerp = easeCubicOut(elapsed / dur);
        const nextLeft = from + (to - from) * lerp;

        // $slider.scrollLeft = from + (to - from) * lerp;
        $slider.scrollTo(nextLeft, 0);
        if (elapsed > dur) {
          $slider.scrollLeft = to;
          if (OS === 'iOS')
            $slider.style.scrollSnapType = '';
          return;
        }
        window.requestAnimationFrame(animate);
      }

      return animate();
    }

    $slider.scrollTo({ left: nextScroll, behavior: 'smooth' });
  };
}

export function bindScrollSlideVert ($slider, { dist, gap, dur = 1500 } = {}) {
  return function _scrollSlideVert (dir) {
    const { offsetHeight, scrollHeight, scrollTop } = $slider;
    const style = window.getComputedStyle($slider);
    gap = gap || parseInt(style.getPropertyValue('row-gap'), 10) || 0;
    const hasSmoothBehavior = style.getPropertyValue('scroll-behavior') === 'smooth';
    dist = dist || (offsetHeight + gap);

    let nextScroll = scrollTop + dist * Math.sign(dir || 1);

    // if (nextScroll < 0)
    //   nextScroll = scrollHeight - offsetHeight;
    // else if (nextScroll >= scrollHeight)
    //   nextScroll = 0;

    if (!hasSmoothBehavior) {
      let from = scrollTop;
      let to = nextScroll;
      let start = Date.now();
      if (OS === 'iOS' || OS === 'Mac')
        $slider.style.scrollSnapType = 'none';
      function animate () {
        const now = Date.now();
        const elapsed = now - start;
        const lerp = easeCubicOut(elapsed / dur);
        const nextTop = from + (to - from) * lerp;

        // $slider.scrollTop = from + (to - from) * lerp;
        $slider.scrollTo(nextTop, 0);
        if (elapsed > dur) {
          $slider.scrollTop = to;
          if (OS === 'iOS')
            $slider.style.scrollSnapType = '';
          return;
        }
        window.requestAnimationFrame(animate);
      }

      return animate();
    }

    $slider.scrollTo({ top: nextScroll, behavior: 'smooth' });
  };
}

export function formatError (err) {
  const html = { title: '', text: '' };

  if (!err)
    return Object.assign(html, { text: 'Unknown error' });

  if (!err.response)
    return Object.assign(html, { text: err.message || err });

  html.title = err.response.status;

  if (!err.response.data)
    return Object.assign(html, { text: err.response.statusText });

  if (typeof err.response.data === 'object')
    return Object.assign(html, {
      text: err.response.data.message || JSON.stringify(err.response.data, null, 2),
    });

  if (typeof err.response.data === 'string')
    return Object.assign(html, { text: err.response.statusText });
}

export default formatError;
